export default __webpack_public_path__ + "static/media/microsoft-dynamics-365.0d6b906d.jpg";